var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "83px",
    viewBox: "0 0 216 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-states",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    transform: "translate(-15.000000, -36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(15.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 109.25,
    y: 35.25,
    width: 19.5,
    height: 19.5,
    rx: 9.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1922629,18 C79.1822831,18.1135833 79.1838993,18.2299482 79.1981938,18.3476941 L86.529277,78.7348987 C86.748199,80.5381642 88.3710351,81.8205091 90.1539865,81.599099 L137.771682,75.6857608 C139.554633,75.4643476 140.822531,73.823021 140.603612,72.0197551 L140.23701,69 L145,69 C147.209139,69 149,67.209139 149,65 L149,14.6167796 C149,13.5559347 148.578589,12.5385375 147.82847,11.7883954 L138.040372,2 L206.946108,2 C211.946434,2 216,5.581722 216,10 C216,14.418278 211.946434,18 206.946108,18 L155.209581,18 C160.209907,18 164.263473,21.581722 164.263473,26 C164.263473,30.418278 160.209907,34 155.209581,34 L183.664671,34 C188.664997,34 192.718563,37.581722 192.718563,42 C192.718563,46.418278 188.664997,50 183.664671,50 L170.505598,50 C164.200838,50 159.08982,53.581722 159.08982,58 C159.08982,60.9455187 161.676647,63.6121853 166.850299,66 C171.850626,66 175.904192,69.581722 175.904192,74 C175.904192,78.418278 171.850626,82 166.850299,82 L59.497006,82 C54.4966794,82 50.4431138,78.418278 50.4431138,74 C50.4431138,69.581722 54.4966794,66 59.497006,66 L9.05389222,66 C4.05356562,66 0,62.418278 0,58 C0,53.581722 4.05356562,50 9.05389222,50 L60.7904192,50 C65.7907458,50 69.8443114,46.418278 69.8443114,42 C69.8443114,37.581722 65.7907458,34 60.7904192,34 L28.4550898,34 C23.4547632,34 19.4011976,30.418278 19.4011976,26 C19.4011976,21.581722 23.4547632,18 28.4550898,18 L79.1922629,18 Z M79.1971532,17.9522935 C74.6647097,17.5147555 71.1377246,14.1213192 71.1377246,10 C71.1377246,5.581722 75.1912902,2 80.1916168,2 L94.5351255,2 C94.1947888,2.58834587 94,3.27142525 94,4 L94,14.9878237 L80.6310554,16.5126151 C80.6254235,16.5133066 80.6197913,16.5139981 80.614159,16.5146897 C79.8554599,16.608909 79.2832877,17.2173512 79.1971532,17.9522935 Z M206.946108,50 C201.945781,50 197.892216,46.418278 197.892216,42 C197.892216,37.581722 201.945781,34 206.946108,34 C211.946434,34 216,37.581722 216,42 C216,46.418278 211.946434,50 206.946108,50 Z M87.7760476,15.7020698 L91.5059641,15.2789032 L87.7760476,15.7020698 Z",
    id: "Combined-Shape",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(78.000000, 0.000000)",
    stroke: "#6A6666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1493363,68.2778186 C62.2502866,69.1093601 62.4017119,70.3566722 62.6036123,72.0197551 C62.8225312,73.823021 61.5546326,75.4643476 59.7716817,75.6857608 L12.1539876,81.5991083 C10.3710351,81.8205091 8.74819896,80.5381642 8.52926762,78.7348999 L1.19819383,18.3476941 C1.0887344,17.4460611 1.72268368,16.6253978 2.61415899,16.5146897 C2.61979127,16.5139981 2.62542347,16.5133066 2.63105536,16.5126151 L16.1427154,14.9715463 M9.77604757,15.7020698 L13.5059641,15.2789032",
    id: "Shape",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,1.25 C18.4812169,1.25 17.25,2.48121694 17.25,4 L17.25,65 C17.25,66.5187831 18.4812169,67.75 20,67.75 L67,67.75 C68.5187831,67.75 69.75,66.5187831 69.75,65 L69.75,14.6167796 C69.75,13.8874487 69.4602802,13.1879881 68.9445732,12.6722655 L58.3281159,2.05548588 C57.8123885,1.53974277 57.1129026,1.25 56.3835428,1.25 L20,1.25 Z",
    id: "Rectangle",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9973303,2.19895163 L56.9973303,11.7327198 C56.9973303,13.094782 58.0967543,14.1989516 59.4529625,14.1989516 L68.9973303,14.1989516",
    id: "Shape",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,2.5 L40.9958905,2.39539981",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(40.000000, 2.000000) rotate(3.000000) translate(-40.000000, -2.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,5.5 L43.9958905,5.39539981",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(43.000000, 5.000000) rotate(3.000000) translate(-43.000000, -5.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0530202,8.4986654 L41.0489107,8.39406521",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(40.053020, 7.998665) rotate(3.000000) translate(-40.053020, -7.998665) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,11.5 L43.9958905,11.3953998",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(43.000000, 11.000000) rotate(3.000000) translate(-43.000000, -11.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,17.5 L43.9958905,17.3953998",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(43.000000, 17.000000) rotate(3.000000) translate(-43.000000, -17.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1060405,23.4973308 L44.101931,23.3927306",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(43.106040, 22.997331) rotate(3.000000) translate(-43.106040, -22.997331) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,14.5 L40.9958905,14.3953998",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(40.000000, 14.000000) rotate(3.000000) translate(-40.000000, -14.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,20.5 L40.9958905,20.3953998",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(40.000000, 20.000000) rotate(3.000000) translate(-40.000000, -20.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,26.5 L40.9958905,26.3953998",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(40.000000, 26.000000) rotate(3.000000) translate(-40.000000, -26.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,29.5 L43.9958905,29.3953998",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(43.000000, 29.000000) rotate(3.000000) translate(-43.000000, -29.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,32.5 L40.9958905,32.3953998",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(40.000000, 32.000000) rotate(3.000000) translate(-40.000000, -32.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0013521,45.5509122 L34.9717957,45.4476456",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(33.986574, 45.499279) rotate(3.000000) translate(-33.986574, -45.499279) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0530184,51.1323179 L36.470403,49.4773658",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(36.053018, 50.053814) rotate(3.000000) translate(-36.053018, -50.053814) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,51.431396 L48.4763902,50",
    id: "Line",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(47.738195, 50.715698) scale(-1, 1) rotate(3.000000) translate(-47.738195, -50.715698) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7086923,40.90598 L37.126077,39.2510278",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(36.708692, 39.827476) scale(1, -1) rotate(3.000000) translate(-36.708692, -39.827476) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,51.431396 L48.4763902,50",
    id: "Line",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(47.738195, 50.715698) scale(-1, 1) rotate(3.000000) translate(-47.738195, -50.715698) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7086923,39.90598 L48.126077,38.2510278",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(47.708692, 38.827476) rotate(3.000000) translate(-47.708692, -38.827476) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,51.431396 L48.4763902,50",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(47.738195, 50.715698) scale(-1, 1) rotate(3.000000) translate(-47.738195, -50.715698) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9979452,45.5523001 L50.9938357,45.4476999",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(49.997945, 45.052300) rotate(3.000000) translate(-49.997945, -45.052300) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,37.5 L42.9958905,37.3953998",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(42.000000, 37.000000) rotate(93.000000) translate(-42.000000, -37.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9979452,53.5523001 L42.9938357,53.4476999",
    id: "Line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(41.997945, 53.052300) rotate(93.000000) translate(-41.997945, -53.052300) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9979452,2.55230009 L39.9938357,2.44769991",
    id: "Line",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(38.997945, 2.052300) rotate(3.000000) translate(-38.997945, -2.052300) "
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6A6666",
    x: 117,
    y: 43,
    width: 4,
    height: 4,
    rx: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultEmptyState);
export default __webpack_public_path__ + "static/media/vault-empty-state.00f0bae9c95ba4efa39c35690a813aae.svg";
export { ForwardRef as ReactComponent };